import React from 'react';

import { App } from '../../App';
import { Stack, StyledLeftSideBar, Surface } from '../../styles/Containers'
import { AccountForm } from './AccountForm'
import { RouteBreadCrumbs } from '../../routes';
import { SettingsNavigation } from '../../capturecollab/components/Dashboard/SettingsNavigation';
import { StorageUsage } from '../../capturecollab/components/Usage/StorageUsage';
import { Divider } from '@mui/material';

export const AccountSettingsPage = () => {

    return (
        <App title="Account Settings">
            <StyledLeftSideBar>
                <SettingsNavigation />
                <Stack>
                    <AccountForm />
                    <Divider />
                    <StorageUsage />
                </Stack>
            </StyledLeftSideBar>
        </App>
    )
}